module.exports = __webpack_public_path__ + "img/price.71215b7d.svg";